import { nuiCtx } from '../../../common/initialization';
import { useEffect } from 'react';

let startCounter = 0,
    cashinSubscription = null,
    subscriptionsIdCounter = 0;

export function startCashinSubscription() {
    startCounter++;
    if (startCounter === 1) {
        subscriptionsIdCounter++;
        cashinSubscription = nuiCtx.pushClient.subscription({
            onMessage(msg) {
                nuiCtx.handlers.cashinOfferPush(msg);
            },
            onSnapshot(messages) {
                nuiCtx.handlers.cashinOfferSnapshot(messages);
            },
            onFailure(error) {
                console.error('[push-js-client]', error);
                nuiCtx.handlers.cashinOfferFailure(error);
            }
        });
        cashinSubscription.cashinSubscriptionId = subscriptionsIdCounter;
        cashinSubscription.resetPaths(['/user-cashin-offer/']);
    }
}

export function resetCashinSubscription() {
    cashinSubscription.reload();
}

export function stopCashinSubscription() {
    --startCounter;
    if (startCounter === 0) {
        cashinSubscription.close();
    }
}
export function useCashinOfferSubscription() {
    useEffect(() => {
        startCashinSubscription();
        return () => {
            stopCashinSubscription();
        };
    }, []);
}
